import React, { createContext, useContext, useState } from 'react';

// Define the context type
interface SidebarContextType {
  verticleSidebar: boolean;
  setVerticleSidebar: (value: boolean) => void;
}

// Create the context with default values
const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

// SidebarProvider component
export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [verticleSidebar, setVerticleSidebar] = useState(true);

  return (
    <SidebarContext.Provider value={{ verticleSidebar, setVerticleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};

// Custom hook to use SidebarContext
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
